import React from "react";
import { Image } from "primereact/image";
import defaultImage from "../../assets/news/news.jpeg";
import { Translate } from "react-auto-translate";
import MoreButton from "../buttons/MoreButton";
import { useNavigate } from "react-router-dom";
import Wrapper from "../containers/Wrapper";
import { Badge } from "primereact/badge";

export default function News() {
  const data = [
    {
      id: 3,
      type: "News",
      date: "April 22, 2024",
      image:
        "https://github.com/phwed/ASSETS-REPO/blob/main/justis/flyer.png?raw=true",
      title:
        "Call for Clean Agricultural Technologies(INFoCAT)",
      url: "https://social.justis.africa/posts/oOMhNmB5jaVVJGDTckMBe6vlopu1",
    },
    {
      id: 1,
      image:
        "https://i.unu.edu/media/inra.unu.edu/publication/5800/Picture4-640x360.jpg",
      type: "News",
      date: "January 13, 2023",
      title: "It’s time to create an ‘After Carbon’ agenda for Africa",

      url: "https://inra.unu.edu/publications/articles/its-time-to-create-an-after-carbon-agenda-for-africa.html",
    },

    {
      id: 2,
      type: "News",
      date: "October 6, 2022",
      image:
        "https://i.unu.edu/media/inra.unu.edu/publication/5746/Picture6-640x360.jpg",
      title:
        "Fragility and Resilience in Green Development in Africa: Intersections and Trade-offs",
      url: "https://inra.unu.edu/publications/articles/fragility-and-resilience-in-green-development-in-africa-intersections-and-trade-offs.html",
    },
    
  ];

  const navigate = useNavigate();

  return (
    <Wrapper className="flex flex-column w-11 gap-5 mx-auto">
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center w-12 mb-2">
        <strong className="text-2xl md:text-4xl">
          <Translate>News and Events</Translate>
        </strong>

        <MoreButton text="See More" onClick={() => navigate("/media/news")} />
      </div>

      <div className="scroller gap-3 w-full">
        {data.map((item, index) => {
          return (
            <a
              href={item.url}
              key={index}
              target="_blank"
              rel="noreferrer"
              className="text-color no-underline flex-auto flex-shrink-0"
            >
              <NewsItem key={index} item={item} />
            </a>
          );
        })}
      </div>
    </Wrapper>
  );
}

// News items
const NewsItem = ({ item }) => {
  return (
    <div className="w-full">
      <div className="h-15rem w-15rem md:h-20rem md:w-20rem lg:h-27rem lg:w-27rem bg-green-100 border-1 border-gray-200">
        <Image
          src={item?.image ?? defaultImage}
          alt={item?.id}
          imageClassName="h-full w-full"
          imageStyle={{
            objectFit: "cover",
          }}
        />
      </div>

      <div className=" w-15rem md:w-20rem lg:w-27rem">
        <div className="flex gap-2 md:gap-3 align-items-center  mt-3">
          <Badge
            value={<Translate>{item.type}</Translate>}
            className="border-round-2xl text-xs md:text-sm bg-primary-300 text-color px-3 md:hidden"
            size="small"
          />
          <Badge
            value={<Translate>{item.type}</Translate>}
            className="border-round-2xl text-xs md:text-sm bg-primary-300 text-color px-3 hidden md:flex"
            size="large"
          />
          <div className="text-xs md:text-base font-light">
            <Translate>{item.date}</Translate>
          </div>
        </div>
        <p className="text-sm md:text-xl mb-0 font-semibold">
          <Translate>{item?.title}</Translate>
        </p>
      </div>
    </div>
  );
};
